import styles from "./PageNotFound.module.scss";
import Grid from "../../config/Grid/Grid";
import tornPaperImage from "../../assets/images/torn-paper.png";
import LanguageSwitch from "../../components/LanguageSwitch/LanguageSwitch";
import Button from "../../components/Button/Button";
import { useTranslation } from "react-i18next";

function PageNotFoundButtonLabel() {
  const { t } = useTranslation();

  return (
    <div className={styles.pageNotFoundButtonLabel}>
      <p className={`${styles.pageNotFoundText} body-bold-small`}>
        {t("notFound.buttonLabel.firstPart")}{" "}
      </p>
      <p className={`${styles.pageNotFoundText} body-small-logo`}>
        {t("notFound.buttonLabel.secondPart")}
        <mark className="mark-white">
          {t("notFound.buttonLabel.thirdPart")}
        </mark>
      </p>
    </div>
  );
}
function PageNotFound() {
  const { t } = useTranslation();
  const buttonLabel = PageNotFoundButtonLabel();
  return (
    <Grid>
      <div className={`start-1 col-4 ${styles.pageNotFoundWrapper}`}>
        <div className={styles.pageNotFoundContainer}>
          <img
            src={tornPaperImage}
            alt="Torn paper"
            className={styles.tornPaperImage}
          />
          <div className={styles.pageNotFoundContent}>
            <div className={styles.pageNotFoundHeader}>
              <h1 className={`${styles.pageNotFoundTitle} headline-bold-small`}>
                <mark className="mark-orange">
                  {t("notFound.title.firstPart")}
                </mark>
                {t("notFound.title.secondPart")}
              </h1>
              <LanguageSwitch dark />
            </div>
            <div className={styles.pageNotFoundTextContainer}>
              <p className={`${styles.pageNotFoundText} title-small`}>
                {t("notFound.description.firstPart")}
              </p>
              <p className={`${styles.pageNotFoundText} title-small`}>
                {t("notFound.description.secondPart")}{" "}
                <mark className="mark-orange">
                  {t("notFound.description.thirdPart")}
                </mark>
              </p>
            </div>
            <Button
              onClick={() => {}}
              label={buttonLabel}
              variant="contained"
              color="secondary"
              maxWidth
              mobile={true}
            />
          </div>
        </div>
      </div>
    </Grid>
  );
}

export default PageNotFound;
